var _line, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlower4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 130,
    viewBox: "0 0 132 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 66.7238,
    y1: 15.8581,
    x2: 66.7238,
    y2: 28.547,
    stroke: "black",
    strokeWidth: 0.837253,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.7529 15.7622C66.4593 12.2689 66.7899 7.90694 57.5146 7.99644C59.1762 15.3657 62.5331 15.8029 66.7529 15.7622Z",
    fill: "#CCFF90",
    stroke: "black",
    strokeWidth: 0.62794,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6963 15.7603C66.9899 12.267 66.6593 7.90499 75.9347 7.99449C74.273 15.3638 70.9161 15.8009 66.6963 15.7603Z",
    fill: "#CCFF90",
    stroke: "black",
    strokeWidth: 0.62794,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.314 11.834C63.4775 12.343 65.9355 13.7975 66.4591 15.5428",
    stroke: "black",
    strokeWidth: 0.62794,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9126 15.5433C67.2035 14.7434 68.2652 12.9254 70.185 12.0527",
    stroke: "black",
    strokeWidth: 0.62794,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.44 52.7391C45.8513 52.7391 45.3741 52.2619 45.3741 51.6733C45.3741 51.0846 45.8513 50.6074 46.44 50.6074C47.0287 50.6074 47.5059 51.0846 47.5059 51.6733C47.5059 52.2619 47.0287 52.7391 46.44 52.7391Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.05212,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.764 55.7152C38.9317 55.7152 38.2569 55.0405 38.2569 54.2082C38.2569 53.3759 38.9317 52.7012 39.764 52.7012C40.5963 52.7012 41.271 53.3759 41.271 54.2082C41.271 55.0405 40.5963 55.7152 39.764 55.7152Z",
    fill: "#FF80AB",
    stroke: "#FF80AB",
    strokeWidth: 1.48761,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1238 57.223C62.2915 57.223 61.6168 56.5483 61.6168 55.716C61.6168 54.8837 62.2915 54.209 63.1238 54.209C63.9561 54.209 64.6309 54.8837 64.6309 55.716C64.6309 56.5483 63.9561 57.223 63.1238 57.223Z",
    fill: "#FF80AB",
    stroke: "#FF80AB",
    strokeWidth: 1.48761,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6251 53.4677C56.0364 53.4677 55.5592 52.9905 55.5592 52.4018C55.5592 51.8131 56.0364 51.3359 56.6251 51.3359C57.2137 51.3359 57.6909 51.8131 57.6909 52.4018C57.6909 52.9905 57.2137 53.4677 56.6251 53.4677Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.05212,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7199 56.7988C47.9094 63.1782 54.2334 61.6702 54.4624 57.1541",
    stroke: "black",
    strokeWidth: 1.05212,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8086 86.4004C46.8634 88.9585 45.726 92.1542 45.7181 92.186C45.5899 92.7052 45.405 93.2112 45.2223 93.7198C44.7785 94.9533 44.2381 96.1498 43.7948 97.3832C42.379 101.322 40.8133 105.133 39.0773 108.971C38.5053 110.236 37.8201 112.104 36.2507 112.689C31.8582 114.327 24.0683 110.886 24.2381 117.797C24.4337 122.849 41.137 132.231 45.9142 127.154C52.2576 120.792 59.7601 96.1786 62.9699 86.819",
    stroke: "black",
    strokeWidth: 0.837253,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.895 86.8187C66.0518 98.5811 71.7502 106.236 72.1603 106.706C74.2313 109.079 75.8441 110.139 79.0513 111.151C80.6194 111.645 83.2481 111.512 84.4337 112.665C85.1699 113.381 85.2917 114.727 85.1277 115.632C84.5327 118.909 82.0896 122.157 85.55 124.885C86.3353 125.505 87.3843 126.004 88.4807 125.957C89.4493 125.915 90.3422 125.739 91.2505 125.432C92.5043 125.007 93.6538 124.516 94.7026 123.779C99.1981 120.618 104.605 111.774 100.638 106.706C98.3249 103.751 91.7188 102.8 88.0754 100.83C86.436 99.9429 85.2158 98.6793 84.529 97.1431C84.3257 96.6893 84.1272 96.2434 84.0305 95.7635C84.005 95.6379 83.3231 94.4357 81.2896 86.6094",
    stroke: "black",
    strokeWidth: 0.837253,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8035 60.1196C89.7337 61.2404 90.7211 62.3125 91.7618 63.3316C97.7051 69.2482 111.729 80.5338 125.819 72.3601C127.408 71.4452 129.518 72.32 130.413 74.3634C131.749 77.3685 131.455 81.649 121.732 84.2066C121.632 84.2417 121.549 84.3139 121.5 84.4084C121.452 84.5028 121.442 84.6123 121.472 84.7142C121.779 86.3636 122.433 92.0598 115.014 85.9228C114.773 85.7213 114.5 85.5611 114.206 85.4487C111.488 84.4403 96.3495 78.664 89.1374 72.3334C88.376 71.6781 87.6723 70.9587 87.0338 70.1831",
    stroke: "black",
    strokeWidth: 0.837253,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2338 70.9697C18.6961 72.8514 12.4391 73.0676 6.1689 69.4302C4.57957 68.5154 2.46936 69.3902 1.57453 71.4336C0.238956 74.4386 0.532783 78.7192 10.2558 81.2768C10.356 81.3119 10.4389 81.3841 10.4873 81.4785C10.5358 81.573 10.5461 81.6825 10.5162 81.7843C10.209 83.4338 9.55458 89.13 16.9737 82.993C17.215 82.7915 17.4881 82.6313 17.7817 82.5189C19.1027 82.0288 23.3577 80.4124 28.2107 78.1535",
    stroke: "black",
    strokeWidth: 0.837253,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0089 57.421C24.0093 52.788 25.4212 36.4192 39.7181 35.0563M46.1395 35.3745C43.7583 34.9596 41.6238 34.8747 39.7181 35.0563M39.7181 35.0563C39.7181 20.2973 66.3047 10.3791 77.6789 27.0869M81.2673 35.0563C80.3936 31.912 79.1663 29.2718 77.6789 27.0869M77.6789 27.0869C88.2551 22.7766 104.686 36.0045 97.3203 55.1114M97.3203 55.1114C95.379 54.9081 94.4412 54.8696 91.845 55.6308M97.3203 55.1114C103.39 56.0357 108.031 62.3151 108.168 69.0268C108.195 70.3483 108.048 71.6864 107.702 73.0038C107.647 73.2137 107.587 73.423 107.521 73.6317M30.464 56.5812C19.1324 59.3107 18.7546 86.6063 53.5049 86.6063H80.5117C91.2177 86.7035 98.2902 84.2855 102.602 80.7484",
    stroke: "black",
    strokeWidth: 0.837253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8867 86.6094L62.748 87.028L60.6548 94.1446C57.6022 89.2556 53.5382 87.8653 47.8867 86.6094Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1672 87.0293L83.2604 93.0994C77.0792 89.7174 72.7947 89.1224 66.0967 87.0293H81.1672Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3755 29.2537C64.4221 28.6258 67.1013 27.8722 69.4456 29.8817",
    stroke: "black",
    strokeWidth: 0.837253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.689 1.04164L107.295 5.38009L107.352 5.53598L107.508 5.59366L111.847 7.19904L107.508 8.80441L107.352 8.86209L107.295 9.01798L105.689 13.3564L104.084 9.01798L104.026 8.86209L103.87 8.80441L99.5319 7.19904L103.87 5.59366L104.026 5.53598L104.084 5.38009L105.689 1.04164Z",
    fill: "#CCFF90",
    stroke: "black",
    strokeWidth: 0.722972
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.24 99.4108L118.17 101.923L118.228 102.079L118.383 102.137L120.896 103.066L118.383 103.996L118.228 104.054L118.17 104.21L117.24 106.722L116.311 104.21L116.253 104.054L116.097 103.996L113.585 103.066L116.097 102.137L116.253 102.079L116.311 101.923L117.24 99.4108Z",
    fill: "#CCFF90",
    stroke: "black",
    strokeWidth: 0.722972
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96156 36.1744L10.0614 39.1467L10.1191 39.3026L10.275 39.3603L13.2472 40.4601L10.275 41.5599L10.1191 41.6176L10.0614 41.7735L8.96156 44.7457L7.86173 41.7735L7.80405 41.6176L7.64816 41.5599L4.67591 40.4601L7.64816 39.3603L7.80405 39.3026L7.86173 39.1467L8.96156 36.1744Z",
    fill: "#CCFF90",
    stroke: "black",
    strokeWidth: 0.722972
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower4);
export default __webpack_public_path__ + "static/media/Flower4.210aaf83345b808664beb20f4845e54e.svg";
export { ForwardRef as ReactComponent };